import DummyLayoutViewModelT from '@/ViewModels/Controls/DummyLayoutViewModel';
import AsyncLayoutFactory from '@/Factories/AsyncLayoutFactory';
import ComponentManager from '@/Management/ComponentManager';
import DummyLayout from '@/Controls/DummyLayout';

export default class DummyLayoutFactory extends AsyncLayoutFactory {
    public viewModel: DummyLayoutViewModelT;
    private jQueryControl: JQuery;
    private control: DummyLayout;
    private DummyLayoutViewModel = ComponentManager.getViewModel<typeof DummyLayoutViewModelT>('DummyLayoutViewModel');
    private DummyLayout = ComponentManager.getControl<typeof DummyLayout>('DummyLayout');

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.viewModel = new this.DummyLayoutViewModel({
            tuples: this.tuples,
            labelColumnWidth: this.context.labelColumnWidth
        });
        this.control = new this.DummyLayout(this.viewModel);
        const tuple = await this.control.getTupleAsync();
        this.jQueryControl = tuple.control;
        return this.jQueryControl;
    }
}

ComponentManager.setFactory('DummyLayout', DummyLayoutFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');